import React from 'react';
import styles from './CalendlyEventTypeTimesSelector.module.scss';
// import PerfectScrollbar from 'react-perfect-scrollbar';
import AppLoader from 'components/contentLoaders/appLoader';
import PageBuilderService from 'api/services/page-builder';
import { ICalendlyEventTypeTimesSelectorProps } from './ICalendlyEventTypeTimesSelectorProps'
import { formatDateToLocal } from 'api/services/page-builder/domain';
import miscUtils from 'utils/miscUtils';

const CalendlyEventTypeSelector: React.FC<ICalendlyEventTypeTimesSelectorProps> = (props) => {

  const [loading, setLoading] = React.useState<boolean>(true);
  const [eventTypeTimes, setEventTypeTimes] = React.useState<Array<any>>([]);

  React.useEffect(() => {
    if(props.eventTypeUri) {
      getEventAvailableTimes();
    } else {
      setLoading(false);
    }
  }, [props.eventTypeUri]);

  const getEventAvailableTimes = () => {
    setLoading(true);
    PageBuilderService.getInstance()
    .getCalendlyEventAvailableTimes(props.group.id, props.eventTypeUri)
    .then((response: any) => {
        if(response.collection && response.collection.length) {
          props.selectItem(response.collection[0]);
        }
        setEventTypeTimes(response.collection);
        setLoading(false);
    })
    .finally(() => setLoading(false))
  };

//   const isSelected = (targetEventType: any): boolean => {
//     return props.filterOutSelected && props.filterOutSelected.find((eventType: any) => eventType.slug === targetEventType.slug) ? true : false;
//   } 

  return (
    <div className={styles.event_type_times_selector_container}>
      {loading ? (
        <AppLoader
          label="Loading event spots..."
          labelStyles={props.labelStyles}
        />
      ) : (
        <>
          <div className={styles.event_type_times_selector_items_container}>
            {eventTypeTimes.length === 0 ? (
              <div className={styles.event_type_times_selector_empty_container}>
                <p className={styles.event_type_times_selector_empty_text}>No results found</p>
              </div>
            ) : (
              // <PerfectScrollbar
              //   className={styles.event_type_times_selector_items_scrollarea}
              //   options={{
              //     wheelPropagation: false,
              //   }}
              // >
              <>
                {eventTypeTimes.filter((eventTypeTime: any, index: number) => index < props.slots).map((eventTypeTime: any, index: number) => {
                  
                  return (
                    <div
                      key={index}
                      className={`${styles.event_type_times_selector_item_container}${props.elementContainerClass ? ` ${props.elementContainerClass}` : ''}`}
                      onClick={() => props.selectItem(eventTypeTime)}
                    >
                      <p 
                      className={styles.event_type_times_selector_item_name}
                      style={props.labelStyles ? props.labelStyles : undefined}
                      >
                        {formatDateToLocal(eventTypeTime.start_time)}
                        {miscUtils.getReadableTimezoneOffset(miscUtils.getUserTimezone()) ? ` (${miscUtils.getUserTimezoneAbbreviation()} ${miscUtils.getReadableTimezoneOffset(miscUtils.getUserTimezone())})` : ''}
                      </p>
                    </div>
                  )
                })}
              </>
              // </PerfectScrollbar>
            )}
          </div>
        </>
      )}
    </div>
  )
}

export default CalendlyEventTypeSelector;